import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "../components/Reveal";
import SEO from "../components/SEO";
import { CASE_STUDIES } from "../caseStudies";

export default function Insights() {
  const items = Object.values(CASE_STUDIES);
  return (
    <div data-testid="insights-page">
      <SEO
        title="Insights — Case Studies & Ideas | The Next Design"
        description="Case studies and thinking from The Next Design: branding, Virtual Plant Visits, 3D and AR work for manufacturers."
      />
      <section className="border-b border-neutral-200">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <SectionTag>Insights</SectionTag>
            <h1 className="font-display text-5xl sm:text-6xl font-light tracking-tight text-black" data-testid="insights-heading">
              Ideas that do something.
            </h1>
            <p className="mt-6 text-lg font-light text-neutral-600 max-w-xl leading-relaxed">
              Case studies and thinking on branding, 3D, AR and Virtual Plant Visits for manufacturers.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="border-t border-neutral-200">
          {items.map((cs, i) => (
            <Reveal key={cs.slug} delay={i * 0.05}>
              <Link
                to={`/case-studies/${cs.slug}`}
                className="group grid grid-cols-12 items-baseline gap-4 py-8 border-b border-neutral-200"
                data-testid={`insights-row-${cs.slug}`}
              >
                <span className="col-span-2 md:col-span-1 text-xs font-medium tracking-[0.2em] text-neutral-400">0{i + 1}</span>
                <h2 className="col-span-10 md:col-span-6 font-display text-2xl md:text-3xl font-light tracking-tight text-black group-hover:text-brand-red transition-colors">
                  {cs.title}
                </h2>
                <p className="col-span-10 col-start-3 md:col-span-4 md:col-start-auto text-[11px] font-medium tracking-[0.15em] uppercase text-neutral-500">
                  {cs.client}
                </p>
                <ArrowRight size={18} strokeWidth={1.25} className="hidden md:block col-span-1 justify-self-end text-neutral-300 group-hover:text-brand-red group-hover:translate-x-1 transition-all" />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
